import {
    AdminBaseRoles,
    AuthorBaseRoles,
    ReviewerBaseRoles,
} from '@deltek/specification-client/core/Configurations/Authorization'
import { RouteDictionary } from '@deltek/specification-client/core/Models/routeTypes'
import UserProfilePage from 'bpm/pages/UserProfilePage'
import { lazy } from 'react'
import { AnalyticsPageRoutes } from './analyticsPageRoutes'
import { CompanyAccountSettingsPageRoutes } from './companyAccountSettingsPageRoutes'
import { ContactsPageRoutes } from './contactsPageRoutes'
import { ProductsCardManagementPageRoutes } from './productCardManagementPageRoutes'
import { ProductsPageRoutes } from './productsPageRoutes'

const AnalyticsPageLazy = lazy(
    () => import('bpm/pages/AnalyticsPage/AnalyticsPageRouting')
)
const ContactsPageLazy = lazy(() => import('bpm/pages/ContactsPage'))

const ProductCardManagementPageLazy = lazy(
    () => import('bpm/pages/ProductCardManagementPage')
)

const ProductsPageLazy = ProductCardManagementPageLazy

const DashboardPageLazy = lazy(() => import('bpm/pages/DashboardPage'))
const UserCreationPageLazy = lazy(
    () => import('bpm/pages/SettingsPage/UserCreationPage')
)
const UserManagementPageLazy = lazy(
    () => import('bpm/pages/SettingsPage/UserManagementPage')
)
const AccountPageLazy = lazy(() => import('bpm/pages/SettingsPage/AccountPage'))

const ContentManagementPageLazy = lazy(
    () => import('bpm/pages/ContentManagementPage')
)

const CompanyAccountsSettingsPageLazy = lazy(
    () => import('bpm/pages/CompanyAccountsSettingsPage')
)

const ScraperPageLazy = lazy(() => import('bpm/pages/ScraperPage'))
const MatchScorePageLazy = lazy(() => import('bpm/pages/MatchScorePage'))

export const BPMRoutes: RouteDictionary = {
    '/bpm': {
        redirect: 'bpm/home',
        name: 'Project Research Map',
    },

    '/bpm/home': {
        name: 'Project Research Map',
        component: DashboardPageLazy,
    },
    '/bpm/profile': {
        name: 'My Profile',
        component: UserProfilePage,
    },
    '/bpm/products': {
        name: 'Products',
        component: ProductsPageLazy,
        exact: false,
        children: ProductsPageRoutes,
    },
    '/bpm/scraper': {
        name: 'Scraper',
        component: ScraperPageLazy,
        // No allowedRoles: Deltek Admin access requires checking both accountType === 'System'
        // AND the Admin role, which allowedRoles cannot express (it checks role only). Access
        // is controlled by the sidebar showNav guard and server-side GraphQL authorization.
    },
    '/bpm/contacts': {
        name: 'Contacts',
        component: ContactsPageLazy,
        exact: false,
        children: ContactsPageRoutes,
        componentProps: {
            title: 'Contacts',
        },
    },
    '/bpm/analytics': {
        name: 'Analysis and Reports',
        component: AnalyticsPageLazy,
        exact: false,
        children: AnalyticsPageRoutes,
        componentProps: {
            title: 'Analysis and Reports',
        },
    },
    '/bpm/account': {
        name: 'Account Settings',
        component: AccountPageLazy,
        allowedRoles: AdminBaseRoles,
    },
    '/bpm/users': {
        name: 'Manage Users',
        component: UserManagementPageLazy,
        allowedRoles: AdminBaseRoles,
    },
    '/bpm/user-setup': {
        name: 'User',
        component: UserCreationPageLazy,
        allowedRoles: AdminBaseRoles,
    },
    '/bpm/user-setup/:userId': {
        name: 'User',
        component: UserCreationPageLazy,
        allowedRoles: AdminBaseRoles,
    },
    '/bpm/content-management': {
        name: 'Content Management',
        component: ContentManagementPageLazy,
        componentProps: {
            title: 'Content Management',
        },
        allowedRoles: ReviewerBaseRoles,
    },
    '/bpm/product-card-management': {
        name: 'Product Card Management',
        component: ProductCardManagementPageLazy,
        componentProps: {
            title: 'Content Management',
        },
        exact: false,
        children: ProductsCardManagementPageRoutes,
        allowedRoles: AuthorBaseRoles,
    },
    '/bpm/company-accounts': {
        name: 'Company Account Settings',
        component: CompanyAccountsSettingsPageLazy,
        exact: false,
        children: CompanyAccountSettingsPageRoutes,
        componentProps: {
            title: 'Company Account Settings',
        },
    },
    '/bpm/match-score': {
        name: 'Match Score',
        component: MatchScorePageLazy,
    },
}
